import axios from 'axios';

import { USER_PLATFORM_HEADER, USER_PLATFORM_WEBSITE } from 'src/constants';

function setupUserPlatform() {
  axios.defaults.headers[USER_PLATFORM_HEADER] = USER_PLATFORM_WEBSITE;
}

export { setupUserPlatform };
